import { Form } from 'antd';
import { useState, useEffect } from 'react';

import { Notification } from 'src/utils';
import { IProps, DataType } from './groups.type';

const useGroups = (props: IProps) => {
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<[]>([]);

  const [editingKey, setEditingKey] = useState<any>('');

  useEffect(() => {
    handleGroups(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGroups = async (pageNumber: number) => {
    setLoading(true);
    handleCancel();

    try {
      const { data } = await props.fetchGroups(pageNumber);

      setData(data);
    } catch (err: any) {
      return false;
    } finally {
      setLoading(false);
    }
  };

  const isEditing = (record: DataType) => record.id === editingKey;

  const handleEdit = (record: Partial<DataType> & { key: React.Key }) => {
    form.setFieldsValue({ name: '', ...record });
    setEditingKey(record.id);
  };

  const handleCancel = () => {
    setEditingKey('');
  };

  const handleSave = async (id: string) => {
    try {
      const row = (await form.validateFields()) as DataType;

      const newData: any = [...data];

      const index = newData.findIndex((item: any) => id === item.id);

      const response = await props.updateGroup(id, { name: row.name });

      if (!!response) {
        Notification.success({
          title: 'Ok',
          message: 'Grupo atualizado com sucesso',
        });
      }

      if (index > -1) {
        const item: any = newData[index];

        newData.splice(index, 1, {
          ...item,
          ...row,
        });

        setData(newData);
        setEditingKey('');
      } else {
        newData.push(row);
        setData(newData);
        setEditingKey('');
      }
    } catch (errInfo) {
      return Notification.error({
        title: 'Erro',
        message: 'Ocorreu um erro ao atualizar o grupo',
      });
    }
  };

  const handleRemove = async (id: string) => {
    setLoading(true);

    try {
      const data = await props.removeGroup(id);

      if (data) {
        handleGroups(1);
      }
    } catch (err: any) {
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    form,
    data,
    loading,
    isEditing,
    editingKey,
    handleGroups,
    handleEdit,
    handleSave,
    handleCancel,
    handleRemove,
  };
};

export default useGroups;
